
export default {
  name: 'ContextMenu',
  data: function data() {
    return {
      menuList: [],
      colorMenu: null
    };
  },


  methods: {
    init: function init(_ref) {
      var menuList = _ref.menuList,
          event = _ref.event,
          colorMenu = _ref.colorMenu;

      // 单例,防止多次绑定
      document.removeEventListener('click', this.cancel);
      var menu = this.$refs.contextMenu;
      var delX = document.body.clientWidth - event.clientX;
      var delY = document.body.clientHeight - event.clientY;

      if (delX < 120) {
        menu.style.left = event.clientX - 120 + 'px';
      } else {
        menu.style.left = event.clientX + 'px';
      }
      var totalHeight = menuList.length * 32;
      if (colorMenu) {
        totalHeight += 2 * 32;
      }
      if (delY < totalHeight) {
        menu.style.top = event.clientY - totalHeight + 'px';
      } else {
        menu.style.top = event.clientY + 'px';
      }
      document.addEventListener('click', this.cancel);
      this.menuList = menuList;
      if (colorMenu) {
        this.colorMenu = colorMenu;
      } else {
        this.colorMenu = null;
      }
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    menuHandler: function menuHandler(menuItem) {
      menuItem.callback();
      this.cancel();
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.cancel);
  }
};